import { render } from "./StarChartResults.vue?vue&type=template&id=ac6519e6&scoped=true"
import script from "./StarChartResults.vue?vue&type=script&lang=js"
export * from "./StarChartResults.vue?vue&type=script&lang=js"

import "./StarChartResults.vue?vue&type=style&index=0&id=ac6519e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac6519e6"]])

export default __exports__